import { Component, ViewEncapsulation } from '@angular/core';

@Component({
    selector: 'aa-section-t0',
    templateUrl: './section-t0.component.html',
    styleUrls: [
        './section-t0.component.scss'
    ],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class SectionT0Component
{
}
